import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "admin-lte/dist/css/adminlte.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "@fortawesome/fontawesome-free/css/all.min.css";

// admin_lte

import "./index.css";
import App from "./App";
import { FrontPage, AllSports } from "./views/FrontPage";
import { Deposit } from "./views/Deposit";
import { Withdraw } from "./views/Report/Withdraw";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/Authcontext";
import { Withdrawreport } from "./views/Report/Withdrawreport";
import { Depositereport } from "./views/Report/Depositereport";
import { Changepassword } from "./views/Report/Changepassword";
import { Stakebutton } from "./views/Report/Stakebutton";
import { Result } from "./views/Report/Result";
import { Activitylogs } from "./views/Report/Activitylogs";
import SportsBook from "./views/Report/SportsBook";
// import { Home } from './views/home';

// Make jQuery globally available
import $ from "jquery";
// import Bank from "./views/admin/components/Bank";
import ProtectedRoute from "./views/admin/ProtectedRoute";
import SportsBets from "./views/Report/SportsBets";
import { Toaster } from "react-hot-toast";
import Jili from "./views/Jili";
import ProtectedRouteUser from "./views/components/ProtectedRouteUser";
import AviatorGames from "./views/AviatorGames";
import ContactUs from "./views/ContactUs";
import CookiePolicy from "./views/CookiePolicy";
import TurboGames from "./views/GamingProviders/TurboGames";
import EvolutionGames from "./views/GamingProviders/EvolutionGames";
import EzugiGames from "./views/GamingProviders/EzugiGames";
import RedTiger from "./views/GamingProviders/RedTiger";
import MaccGames from "./views/GamingProviders/MaccGames";
import JdbGaming from "./views/GamingProviders/JdbGaming";
import Lobby from "./views/GamingProviders/Lobby";
import LiveCasino from "./views/GamingProviders/LiveCasino";
import JiliAll from "./views/JiliAll";
import JDBAll from "./views/JDBAll";
import Cricket from "./views/Cricket";
import PgSoftAll from "./views/PgSoftAll";
import CQ9All from "./views/CQ9All";
import RummyHome from "./views/GamingProviders/RummyHome";
import SpribeHome from "./views/GamingProviders/SpribeHome";
import CQ9Home from "./views/GamingProviders/CQ9Home";
import PgSoftHome from "./views/GamingProviders/PgSoftHome";
import TurboAll from "./views/TurboAll";
import Titli from "./views/Titli";
import MatkaPage from "./views/MatkaPage";
import Menu from "./views/Menu";
import CategoryGrid from "./views/components/CategoryGrid";
import Register from "./views/RegisterForm";


import CricketReal from "./views/CricketReal";
import FootballReal from "./views/FootballReal";
import TennisReal from "./views/TennisReal";
import FootBAll from "./views/FootBall";
import Tennis from "./views/Tennis";
import Inplays from "./views/Inplays";
import CasinoGames from "./views/CasinoGames";


import { ThemeProvider } from "./context/ThemeContext";
import Rules from "./views/Rules";
import ResponsibleGaming from "./views/ResponsibleGaming";

// Admin screens load on demand (#13): ~60 of them were in the one bundle
// every visitor downloads, though only staff ever open /admin.
const Dashboard = lazy(() => import("./views/admin/Dashboard"));
const AdminUsers = lazy(() => import("./views/admin/components/AdminUsers"));
const AdminUserSetting = lazy(() => import("./views/admin/components/userSetting"));
const AdminSettings = lazy(() => import("./views/admin/components/AdminSettings"));
const AdminRoles = lazy(() => import("./views/admin/components/AdminRoles"));
const AdminMatches = lazy(() => import("./views/admin/components/AdminMatches"));
const ManageMarket = lazy(() => import("./views/admin/components/ManageMarket"));
const MyMarket = lazy(() => import("./views/admin/components/MyMarket"));
const MatchesHistory = lazy(() => import("./views/admin/components/MatchesHistory"));
const FancyHistory = lazy(() => import("./views/admin/components/FancyHistory"));
const ManageFancy = lazy(() => import("./views/admin/components/ManageFancy"));
const Bonus = lazy(() => import("./views/admin/components/Bonus"));
const AdminAddRoles = lazy(() => import("./views/admin/components/AdminAddRoles"));
const AdminLogin = lazy(() => import("./views/admin/AdminLogin"));
const BrowseRecharge = lazy(() => import("./views/admin/components/BrowseRecharge"));
const BrowseWithdrawl = lazy(() => import("./views/admin/components/BrowseWithdrawl"));
const ProfitLoss = lazy(() => import("./views/admin/components/ProfitLoss"));
const DepositHistory = lazy(() => import("./views/admin/components/DepositHistory"));
const WithdrawHistory = lazy(() => import("./views/admin/components/WithdrawHistory"));
const Admin = lazy(() => import("./views/admin/components/Admin"));
const BetHistory = lazy(() => import("./views/admin/components/BetHistory"));
const Master = lazy(() => import("./views/admin/components/Master"));
const AddSlider = lazy(() => import("./views/admin/components/AddSlider"));
const Slider = lazy(() => import("./views/admin/components/Slider"));
const SuperMaster = lazy(() => import("./views/admin/components/SuperMaster"));
const SportHistory = lazy(() => import("./views/admin/components/SportHistory"));
const SuperAdmin = lazy(() => import("./views/admin/components/SuperAdmin"));
const Agent = lazy(() => import("./views/admin/components/Agent"));
const EditSlider = lazy(() => import("./views/admin/components/EditSlider"));
const SuperAdminChip = lazy(() => import("./views/admin/components/SuperAdminChip"));
const UserChip = lazy(() => import("./views/admin/components/UserChip"));
const Profile = lazy(() => import("./views/admin/components/Profile"));
const CommissionHistory = lazy(() => import("./views/admin/components/CommissionHistory"));
const AdminBonus = lazy(() => import("./views/admin/components/AdminBonus"));
const UserStatment = lazy(() => import("./views/admin/components/UserStatement"));
const WeekReport = lazy(() => import("./views/admin/components/WeekReport"));
const CasinoHistory = lazy(() => import("./views/admin/components/CasinoHistory"));
const UserBetHistory = lazy(() => import("./views/admin/components/UserBetHistory"));
const UserSportsSetting = lazy(() => import("./views/admin/components/UserSportsSetting"));
const PromoCode = lazy(() => import("./views/admin/components/PromoCode"));
const AdminBankList = lazy(() => import("./views/admin/components/AdminBankList"));
const MarketAnalysis = lazy(() => import("./views/admin/components/MarketAnalysis"));
const WeeklyReportsUser = lazy(() => import("./views/admin/components/WeeklyReportsUser"));
const MarketAnalysisBets = lazy(() => import("./views/admin/components/MarketAnalysisBets"));
const MarketAnalysisFootBallBets = lazy(() => import("./views/admin/components/MarketAnalysisFootBallBets"));
const MarketAnalysisTennisBets = lazy(() => import("./views/admin/components/MarketAnalysisTennisBets"));
const EditLogo = lazy(() => import("./views/admin/components/EditLogo"));
const EditModal = lazy(() => import("./views/admin/components/EditModal"));
const NewClientPage = lazy(() => import("./views/admin/components/NewClientPage"));
const GlobalSearch = lazy(() => import("./views/admin/components/GlobalSearch"));
const ChildUsers = lazy(() => import("./views/admin/components/ChildUsers"));
const FancyBetsResult = lazy(() => import("./views/admin/components/FancyBetsResult"));
const EventDelay = lazy(() => import("./views/admin/components/EventDelay"));
const DelayPage = lazy(() => import("./views/admin/components/DelayPage"));
const LiveBets = lazy(() => import("./views/admin/components/LiveBets"));
const MatchSummary = lazy(() => import("./views/admin/components/MatchSummary"));
const TodayReport = lazy(() => import("./views/admin/components/TodayReport"));
const LossBack = lazy(() => import("./views/admin/components/LossBack"));
const SettleHistory = lazy(() => import("./views/admin/components/SettleHistory"));
const Settlement = lazy(() => import("./views/admin/components/Settlement"));
const AdminHome = lazy(() => import("./views/admin/components/AdminHome"));
const HomeCricket = lazy(() => import("./views/admin/components/HomeCricket"));
const HomeFootball = lazy(() => import("./views/admin/components/HomeFootball"));
const HomeTennis = lazy(() => import("./views/admin/components/HomeTennis"));
const BetUpdateResult = lazy(() => import("./views/admin/components/BetUpdateResult"));
const AdminClient = lazy(() => import("./views/admin/components/AddClient"));
const Exposure = lazy(() => import("./views/admin/components/Exposure"));
const Accounts = lazy(() => import("./views/admin/components/Accounts"));
const EventBetHistory = lazy(() => import("./views/admin/components/EventBetHistory"));
const NewUserRegister = lazy(() => import("./views/admin/components/NewUserRegister"));
const AdminLayout = lazy(() => import("./views/admin/layouts/AdminLayout"));
const FancyResult = lazy(() => import("./views/admin/components/fancyResult"));
const MatchSummaryReport = lazy(() => import("./views/admin/components/MatchSummaryReport"));




window.jQuery = $;
window.$ = $;

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Router>
    <AuthProvider>
      <ThemeProvider>
      <Toaster position="top-right" reverseOrder={false} />
      <Suspense fallback={<div className="rb-route-loading" aria-busy="true" />}>
      <Routes>
        <Route path="/" element={<FrontPage />} />
        {/* Same page as "/" for everyone. /home used to be the old
            pre-redesign home that logged-in players were sent to; many
            links still point here, so it stays as an alias. */}
        <Route path="/home" element={<FrontPage />} />

        <Route element={<ProtectedRouteUser />}>
          <Route path="/changepassword" element={<Changepassword />} />
          <Route path="/stakebutton" element={<Stakebutton />} />
          <Route path="/deposit" element={<Deposit />} />
          <Route path="/withdraw" element={<Withdraw />} />
          <Route path="/withdrawhistory" element={<Withdrawreport />} />
          <Route path="/depositehistory" element={<Depositereport />} />
          <Route path="/result" element={<Result />} />
          <Route path="/activitylogs" element={<Activitylogs />} />
          {/* These two were template shells: their forms were wired to
              nothing, so Load Report could only reload the page and no data
              ever appeared. The working statements are tabs of the Bets page
              (SportsBets reads state.activeTab: 3 = Account Statement, 4 = Profit & Loss). */}
          <Route path="/plstatement" element={<Navigate to="/sports_bets" state={{ activeTab: 4 }} replace />} />
          <Route path="/accountstatement" element={<Navigate to="/sports_bets" state={{ activeTab: 3 }} replace />} />
        </Route>
      

        <Route path="/jiliAll" element={<JiliAll />} />
        <Route path="/jdbAll" element={<JDBAll />}/>
        <Route path="/pgsoftAll" element={<PgSoftAll />}/>
        <Route path="/cq9All" element={<CQ9All />}/>
        <Route path="/rummyHome" element={<RummyHome />}/> 
        <Route path="/spribeHome" element={<SpribeHome />}/>                      
        <Route path="/cQ9Home" element={<CQ9Home />}/>                      
        <Route path="/pgSoftHome" element={<PgSoftHome />}/>
        <Route path="/turboAll" element={<TurboAll />}/>
        <Route path="/titli" element={<Titli />}/>
        <Route path="/matka" element={<MatkaPage />}/>

        {/* <Route path='/games' element={<Games/>}/>
          <Route path='/sports/:id' element={<Sports/>}/> */}
        <Route path="/live-casino" element={<LiveCasino/>}/>
        <Route path="/jili" element={<Jili />} />
        <Route path="/turbo-games" element={<TurboGames/>}/>
        <Route path="/evolution-games" element={<EvolutionGames/>}/>
        <Route path="/ezugi-games" element={<EzugiGames/>}/>
        <Route path="/redtiger-games" element={<RedTiger/>}/>
        <Route path="/macc-games" element={<MaccGames/>}/>
        <Route path="/jdb-games" element={<JdbGaming/>}/>
        <Route path="/aviator-games" element={<AviatorGames/>}/>
        <Route path="/sportsbook" element={<SportsBook />} />
        <Route path="/sports_bets" element={<SportsBets />} />
        <Route path="/contact-us" element={<ContactUs/>}/>
        <Route path="/cookie-policy" element={<CookiePolicy/>}/>
        <Route path="/app" element={<App />} />
        <Route path="/lobby" element={<Lobby/>}/>
        <Route path="/cricketBet" element={<Cricket />}/>
        <Route path="/footBAllBet" element={<FootBAll />}/>
        <Route path="/tennis" element={<Tennis />}/>
        <Route path="/menu" element={<Menu />}/>
        <Route path="/sportall" element={<AllSports />}/>
        <Route path="/CategoryGrid" element={<CategoryGrid />}/>
        <Route path="/registerPage" element={<Register />}/>
        <Route path="/cricketreal" element={<CricketReal />}/>
        <Route path="/footballreal" element={<FootballReal />}/>
        <Route path="/tennisreal" element={<TennisReal />}/>
        <Route path="/rules" element={<Rules />}/>
        <Route path="/responsible-gaming" element={<ResponsibleGaming />}/>
        <Route path="/inplay" element={<Inplays />}/>
        <Route path="/casinoGames" element={<CasinoGames />}/>


    {/* Admin Login (NO layout) */}
<Route path="/admin/login" element={<AdminLogin />} />

{/* Protected Admin Area */}
<Route element={<ProtectedRoute />}>
  <Route path="/admin" element={<AdminLayout />}>
    
    {/* Default dashboard */}
    <Route index element={<Dashboard />} />
    <Route path="dashboard" element={<Dashboard />} />

    <Route path="Admin" element={<Admin />} />
    <Route path="user" element={<AdminUsers />} />
    <Route path="addClient/:code" element={<AdminClient />} />

    <Route path="userSetting/:user_phone/:user_code" element={<AdminUserSetting />} />
    <Route path="userSetting/:user_phone" element={<AdminUserSetting />} />
    <Route path="userBetHistory/:user_phone" element={<UserBetHistory />} />
    <Route path="userWeeklyReport/:user_phone" element={<WeeklyReportsUser />} />

    <Route path="browse_recharge" element={<BrowseRecharge />} />
    <Route path="browse_withdrawl" element={<BrowseWithdrawl />} />
    <Route path="settings" element={<AdminSettings />} />
    <Route path="accounts" element={<Accounts />} />

    <Route path="roles" element={<AdminRoles />} />
    <Route path="matches" element={<AdminMatches />} />
    <Route path="deposit_history" element={<DepositHistory />} />
    <Route path="withdraw_history" element={<WithdrawHistory />} />

    <Route path="manage_market" element={<ManageMarket />} />
    <Route path="fancyResult" element={<FancyResult />} />
    <Route path="my_market" element={<MyMarket />} />
    <Route path="matches_history" element={<MatchesHistory />} />
    <Route path="matchSummaryReport/:eventId" element={<MatchSummaryReport />}/>

    <Route path="userSportsSetting/:phone" element={<UserSportsSetting />} />
    <Route path="fancyHistory" element={<FancyHistory />} />
    <Route path="manageFancy" element={<ManageFancy />} />

    <Route path="bonus" element={<Bonus />} />
    <Route path="add_roles" element={<AdminAddRoles />} />
    <Route path="profitloss" element={<ProfitLoss />} />

    <Route path="betHistory" element={<BetHistory />} />
    <Route path="master" element={<Master />} />
    <Route path="supermaster" element={<SuperMaster />} />
      <Route path="Agent" element={<Agent />}/>
    <Route path="superAdmin" element={<SuperAdmin />}/>
    <Route path="slider" element={<Slider />} />
    <Route path="addSlider" element={<AddSlider />} />
    <Route path="editSlider/:id" element={<EditSlider />} />
    <Route path="editLogo/:id" element={<EditLogo />} />
    <Route path="editModal/:id" element={<EditModal />} />

    <Route path="adminChip" element={<SuperAdminChip />} />
    <Route path="userChip" element={<UserChip />} />
    <Route path="Profile" element={<Profile />} />

    <Route path="commissionHistory" element={<CommissionHistory />} />
    <Route path="adminbonus" element={<AdminBonus />} />

    <Route path="userStatement" element={<UserStatment />} />
    <Route path="userStatement/:id" element={<UserStatment />} />

    <Route path="casinohistory" element={<CasinoHistory />} />
    <Route path="bankList" element={<AdminBankList />} />

    <Route path="marketAnalysis" element={<MarketAnalysis />} />
    <Route path="cricket/marketBetAnalysis/:marketId2" element={<MarketAnalysisBets />} />
    <Route path="tennis/marketBetAnalysis/:marketId2" element={<MarketAnalysisTennisBets />} />
    <Route path="football/marketBetAnalysis/:marketId2" element={<MarketAnalysisFootBallBets />} />

    <Route path="newclient" element={<NewClientPage />} />
    <Route path="global" element={<GlobalSearch />} />
    <Route path="getChildUsers/:code" element={<ChildUsers />} />
    <Route path="getfancybets/:eventid" element={<FancyBetsResult />} />

    <Route path="exposure/:phone" element={<Exposure />} />
    <Route path="eventDelay" element={<EventDelay />} />
    <Route path="page/eventDelay" element={<DelayPage />} />

    <Route path="liveBets" element={<LiveBets />} />
    <Route path="matchSummary" element={<MatchSummary />} />
    <Route path="todaySummary" element={<TodayReport />} />
    <Route path="lossback" element={<LossBack />} />

    <Route path="weekReport" element={<WeekReport />} />
    <Route path="settleHistory" element={<SettleHistory />} />
    <Route path="settlement" element={<Settlement />} />
   <Route path="sportHistory" element={<SportHistory />}/>
    <Route path="home" element={<AdminHome />} />
    <Route path="homecricket" element={<HomeCricket />} />
    <Route path="homefootball" element={<HomeFootball />} />
    <Route path="hometennis" element={<HomeTennis />} />

    <Route path="newRegister" element={<NewUserRegister />} />
    <Route path="betUpdateResult" element={<BetUpdateResult />} />
    <Route path="eventBetHistory/:eventId" element={<EventBetHistory />} />
     

  </Route>
</Route>

      </Routes>
      </Suspense>
      </ThemeProvider>
    </AuthProvider>

     
   
    
  </Router>
);

reportWebVitals();